// extracted by mini-css-extract-plugin
var _1 = "Qua3d6iXL9";
export { _1 as "root" }
